import { Component, OnInit } from '@angular/core';
import {
  PipelineEntityType,
  PaginatedFilteredProgramSearchResults,
  CurriculumEntitySearchCriteria,

} from '../../../api/datacleanuptool-api.model';
import { BaseRecordsComponent } from '../base-records.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterRecordNoticeService } from '../../../shared/services/master-record-notice.service';
import { ExportSearchResultsService } from '../../../shared/services/export-search-results.service';
import { ServiceManager } from '../../../shared/services/service-manager';
import {ApplicationStateService} from "../../../shared/services/application-state.service";
import {Observable} from "rxjs";
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-program-records',
  templateUrl: './program-records.component.html'
})
export class ProgramRecordsComponent extends BaseRecordsComponent<PaginatedFilteredProgramSearchResults> implements OnInit {

// TODO:   PROGRAM_LEARNING_OUTCOMES: BulkAmendType.PROGRAM_LEARNING_OUTCOMES;

  constructor(
    serviceManager: ServiceManager,
    activatedRoute: ActivatedRoute,
    router: Router,
    protected noticeTypeService: MasterRecordNoticeService,
    protected recordFilterService: ExportSearchResultsService,
    protected applicationStateService: ApplicationStateService,
  ) {
    super(
      serviceManager,
      activatedRoute,
      router,
      noticeTypeService,
      recordFilterService,
      applicationStateService,
      PipelineEntityType.PROGRAM,
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.headerTitle.setTitle(['Program Records']);
    this.applicationState.onProgramUpdated$
      .pipe(takeUntil(this.onNgDestroy))
      .subscribe( updatedEntityId =>{
          this.loadResults();
        }
      );

    this.applicationState.onProgramAdded$
      .pipe(takeUntil(this.onNgDestroy))
      .subscribe( () =>{
          this.loadResults();
        }
      );
  }

  protected findEntities$(criteria: CurriculumEntitySearchCriteria) : Observable<PaginatedFilteredProgramSearchResults>{
    return this.curriculumYear.programs$(criteria, this.page, this.itemsPerPage);
  }

}
